import React, { useEffect, useState, useCallback } from 'react'
import style from '../../../styles/mystyle.module.css'
import Cards from './Cards'
import { Navbar } from '../Layout/Navbar'
import { getCookieValue } from '../../helpers/helpers'
import axios from "axios";
import config from "../../../next.config";
import { useRouter } from "next/router";
import getIncludeStatusIds from "../../helpers/global/getIncludeStatusIds";
import LoadingJSON from '../Loaders/Loading'
import SeeMore from "../SeeMore";
import { getTermsByVocabCode } from '../../helpers/global/term/term';
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import NoData from '../NoData'
import { useTranslation } from "next-i18next";
import { Customeselect } from "./Reservation.style"
import { CustomeFormControl } from "./Reservation.style"
import { CustomeBorder } from "./Reservation.style"
import Stack from '@mui/material/Stack'
import {BorderLinearProgressred ,
     BorderLinearProgressgrey ,
     BorderLinearProgressgreen ,
     BorderLinearProgressyellow,
     BorderCircularProgress
    } from "./Reservation.style"

function Main() {
  const [LoadMore, setLoadMore] = useState(false);
  const [loading, setloading] = useState(true);
  const [pageId, setpageId] = useState(0);
  const [NotFound, setNotFound] = useState(false);
  const [ReservationsList, setReservationsList] = useState([]);
  const [showloading, setShowloading] = useState(true);
  const [CountVisit, setCountVisit] = useState([]);
  const { t } = useTranslation("common");
  const [MyReservationsStatus, setMyReservationsStatus] = useState([]);
  const [MyReservationsStatusStatic, setMyReservationsStatusStatic] = useState([{ id: 1, code: "all", name: t("all") }, { id: 2, code: "Approved", name: t("Approved") }, { id: 3, code: "pending", name: t("padding") }, { id: 4, code: "closed", name: t("canceled") }]);
  const [ReservationStatus, setReservationStatus] = useState("");

  const { locale } = useRouter();
  const [login, setLogin] = useState(false)
  const callbackReload = useCallback(
    (callback) => {

      if (ReservationStatus != null) {
        getMyReservation(1, ReservationStatus.code);
      } else {
        getMyReservation(1)
      }

    },
    [ReservationsList],
  )




  const visitedByCustomer = () => {

    getTermsByVocabCode("entities-operation-types")
      .then(res => {
        let reservationConfiguration = JSON.parse(res).filter(i => i.code == "reservation")

        getTermsByVocabCode(reservationConfiguration[0].field1)
          .then(res => {

            let Status = JSON.parse(res).filter(i => i.vocCode == reservationConfiguration[0].field1)
            let searchData = {

              entityDetailsId: getCookieValue("login").entityDetailsId
            };
            axios
              .get(
                `${config["basePath"]}/api/reservation/get/clinic/countVisitedByCustomer`,
                {
                  params: searchData,
                  headers: {
                    "Content-Type": "application/json",
                    "accept-language": locale
                  }
                }
              )
              .then(resp => {

                if (resp.data.data.response.length > 0 && Status.length) {
                  const list = [{ CountTotal: 0, CountClosed: 0, visitedByCustomerTrue: 0, CountapprovedStatus: 0, CountwaitingForApproved: 0, CountConfirmedReservation: 0 }];

                  let tmpCountTotal = 0
                  let ApprovedReport = resp.data.data.response.filter(
                    i =>
                      i.statusId !=
                      Status.filter(x => x.code == "closed")[0].id
                  );

                  let tmpvisitedByCustomerTrue = ApprovedReport.filter(
                    i => i.visitedByCustomer == true
                  );

                  resp.data.data.response.map(i => (tmpCountTotal += i.countStatusId));
                  list[0]["CountTotal"] = tmpCountTotal;
                  list[0]["visitedByCustomerTrue"] = tmpvisitedByCustomerTrue.length > 0 ? tmpvisitedByCustomerTrue[0].countStatusId : 0;
                  let tmpCountapprovedStatus = 0
                  let tmpCountClosed = 0;
                  let tmpCountwaitingForApproved = 0;
                  let tmpcountvisitedByCustomer = 0
                  let closed = resp.data.data.response.filter(
                    i =>
                      i.statusId ==
                      Status.filter(z => z.code == "closed").map(b => b.id)[0]
                  );

                  closed.map(i => (tmpCountClosed += i.countStatusId));

                  list[0]["CountClosed"] = tmpCountClosed;


                  let waitingForApprovedStatus = Status.filter(
                    z =>
                      z.code == "pending-approval-for-create" ||

                      z.code == "marked-for-create-edit"
                  );
                  resp.data.data.response.filter(i => (waitingForApprovedStatus.map(i => i.id).includes(i.statusId))).map(r => {

                    tmpCountwaitingForApproved += r.countStatusId;
                    // })
                  });


                  list[0]["CountwaitingForApproved"] = tmpCountwaitingForApproved;
                  let approvedStatus = Status.filter(
                    z =>
                      z.code == "approved" ||
                      z.code == "marked-for-edit" ||
                      z.code == "pending-approval-for-delete" ||
                      z.code == "pending-approval-for-edit"
                  );
                  resp.data.data.response.filter(i => (approvedStatus.map(i => i.id).includes(i.statusId))).map(r => {
                    tmpCountapprovedStatus += r.countStatusId;
                  });
                  list[0]["CountapprovedStatus"] = tmpCountapprovedStatus;
                  resp.data.data.response.filter(i => i.visitedByCustomer == true).map(r => {
                    tmpcountvisitedByCustomer += r.countStatusId;
                  });

                  let tmpCountConfirmedReservation = (
                    100 *
                    (tmpcountvisitedByCustomer / tmpCountapprovedStatus)
                  ).toFixed(1);
                  list[0]["CountConfirmedReservation"] = tmpCountConfirmedReservation;

                  setCountVisit(list)
                }
              }).catch(err => (err))
          }).catch(err => (err))
      }).catch(err => (err))
  }
  const getMyReservation = (epageId, ReservationStatus) => {
    getIncludeStatusIds()
      .then(res => {
        let StatusIds = res;
        setloading(true);
        setNotFound(false)
        setpageId(epageId);



        let searchData = {
          createdBy: getCookieValue("login").userID,
          Authorization: getCookieValue("login").Authorization,
          // statusId: JSON.stringify(StatusIds),
          getProduct: "0",
          pageId: epageId,
          limit: 10,
          langId: locale
        };

        if (ReservationStatus) {

          if (ReservationStatus == "all") {

            searchData.statusId = JSON.stringify(MyReservationsStatus.map(i => i.id))
          }

          if (ReservationStatus == "Approved") {
            let ReservationsStatusApproved = MyReservationsStatus.filter(i => i.code == "approved" ||
              i.code == "marked-for-edit" ||
              i.code == "pending-approval-for-delete" ||
              i.code == "pending-approval-for-edit")
            searchData.statusId = JSON.stringify(ReservationsStatusApproved.map(i => i.id))
          }

          if (ReservationStatus == "pending") {
            let ReservationsStatusPending = MyReservationsStatus.filter(i => i.code == "pending-approval-for-create" ||
              i.code == "marked-for-create-edit")
            searchData.statusId = JSON.stringify(ReservationsStatusPending.map(i => i.id))
          }
          if (ReservationStatus == "closed") {
            let ReservationsStatusclosed = MyReservationsStatus.filter(i => i.code == "closed")
            searchData.statusId = JSON.stringify(ReservationsStatusclosed.map(i => i.id))
          }
        }
        setShowloading(true);

        axios
          .get(
            `${config["basePath"]}/api/reservation/getMyReservationForCustomerWithDetails`,
            {
              params: searchData,
              headers: {
                "Content-Type": "application/json",
                "accept-language": locale
              }
            }
          )
          .then(async resp => {

            let tmpData = resp.data.data.data
            if (tmpData.length > 0) {

              let searchData = {
                createdBy: getCookieValue("login").userID,
                statusId: JSON.stringify(StatusIds),
              }
              await axios
                .get(
                  `${config["basePath"]}/api/rating/get/getCommentsForRating`,
                  {
                    params: searchData,
                    headers: {
                      "Content-Type": "application/json",
                      "accept-language": locale
                    }
                  }
                )
                .then(resp2 => {

                  if (resp2.data.data.data.length > 0) {


                    tmpData.map(i => {


                      i.RatingByUser = resp2.data.data.data.filter(
                        f => f.evaluateId == i.entityDetailsId
                      );
                      return i;
                    });
                  }
                })
                .catch(err => (err));


              setloading(false);

              if (epageId > 1) {
                setReservationsList(prevState => [
                  ...prevState,
                  ...tmpData
                ]);
              } else {
                setReservationsList(tmpData)

              }
              setShowloading(false);

            } else {
              setLoadMore(false);
              setNotFound(true)
              setReservationsList([])
              setShowloading(false);

            }

            if (searchData.limit == resp.data.data.numberOfElements) {
              if (searchData.limit * searchData.pageId < resp.data.data.totalElements) {
                setLoadMore(true);
              } else {
                setLoadMore(false);
                setNotFound(true)
                setShowloading(false);

              }
            }




          }).catch(err => (err))
      }).catch(err => (err))

  }
  useEffect(() => {

    if (getCookieValue("login") == false) {
      setLogin(true)
    }
  }, [getCookieValue("login")])
  const getMore = () => {
    let tempPageId = pageId + 1;
    if (ReservationStatus != null) {
      getMyReservation(tempPageId, ReservationStatus.code);
    } else {
      getMyReservation(tempPageId)
    }

  };
  const handleChangeStatus = (event) => {
    let Status = MyReservationsStatusStatic.filter(
      (i) => i.name == event.target.value
    );

    setReservationStatus(Status[0]);


  };
  const handleSubmit = (e) => {
    e.preventDefault();


    if (ReservationStatus != null) {
      setShowloading(true);
      getMyReservation(1, ReservationStatus.code);
    }
  };
  useEffect(() => {
    setShowloading(true);
    visitedByCustomer()
    getMyReservation(1)
    getTermsByVocabCode("entities-operation-types")
      .then(res => {
        let reservationConfiguration = JSON.parse(res).filter(i => i.code == "reservation")
        getTermsByVocabCode(reservationConfiguration[0].field1)
          .then(res => {
            setMyReservationsStatus(JSON.parse(res).filter(i => i.language && i.language.code == locale && i.vocCode == reservationConfiguration[0].field1))
          }).catch(err => (err))
      }).catch(err => (err))
  }, [])

  // progress component
  const [progress, setProgress] = React.useState(10);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);




  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>

      <Navbar showDownloadAppSection={false} exchangeAllCurrenciesCallBack={(res) => (res)} currenciesCallBack={(res) => (res)}>
        {login ? <NoData text={t("sessionEnd")} /> :
          <>
            <div className={style.SectionContainer}>

              <div className={style.allcard}>
                {CountVisit && CountVisit.length ?
                  <div className={style.allcard}>
                    <div className={style.textaboutdoctor1 + " " + style.Blod}>{t("MyBookings")}</div>
                    <div className={style.paddingComment}>
                      <div className={style.stylesComfirmationpage}>
                        <div className={style.TwoGrid}>

                          <div className={style.FourGrid}>

                            <div className={style.lineprogressBook}>

                              <div className={style.textaboutdoctor3 + " " + style.marginbottom + " " + style.paddingzero + " " + style.textalign}>
                                {t("AllMyReservations")}
                              </div>
                              <div> <BorderLinearProgressyellow variant="determinate" value={CountVisit[0].CountTotal * 100 / 100} /></div>
                              {CountVisit[0].CountTotal}
                            </div>
                            <div className={style.lineprogressBook}>
                              <div className={style.textaboutdoctor3 + " " + style.marginbottom + " " + style.paddingzero + " " + style.textalign}>
                                {t("canceled")}

                              </div>
                              <BorderLinearProgressred variant="determinate" value={CountVisit[0].CountClosed * 100 / 100} />
                              {CountVisit[0].CountClosed}

                            </div>

                            <div className={style.lineprogressBook}>
                              <div className={style.textaboutdoctor3 + " " + style.marginbottom + " " + style.paddingzero + " " + style.textalign}>
                                {t("padding")}
                              </div>
                              <BorderLinearProgressgrey variant="determinate" value={CountVisit[0].CountwaitingForApproved * 100 / 100} />
                              {CountVisit[0].CountwaitingForApproved}
                            </div>
                            <div className={style.lineprogressBook}>
                              <div className={style.textaboutdoctor3 + " " + style.marginbottom + " " + style.paddingzero + " " + style.textalign}>
                                {t("Approved")}
                              </div>
                              <BorderLinearProgressgreen variant="determinate" value={CountVisit[0].CountapprovedStatus * 100 / 100} />
                              {CountVisit[0].CountapprovedStatus}
                            </div>


                          </div>
                          <div>
                            <BorderCircularProgress
                              percentage={CountVisit[0].CountConfirmedReservation * 100 / 100}
                              color={"bcbcbc"}
                              strokeWidthLightGray={"0.5rem"}
                              strokeWidth={"0.8rem"}
                              text={t("confirmedCases")}
                              variant="determinate" />




                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : ""}
              </ div>

              <div className={style.allcard} style={{ display: "flex" }} >

                <CustomeBorder className={"w-full"} locale={locale} >
                  <CustomeFormControl variant="outlined" fullWidth>
                    <InputLabel> {t("ReservationStatusLabel")}</InputLabel>
                    <Customeselect
fullWidth
                      labelId="Type"
                      id="Type"

                      value={ReservationStatus.name}
                      onChange={handleChangeStatus}
                      sx={{
                        direction: "rtl",
                        textAlign: " right",
                        width: "100%",
                        margin: "0 ",
                        display: "flex !important",
                        borderRadius: 0,

                      }}
                    >
                      {MyReservationsStatusStatic.map((type) => (
                        <MenuItem value={type && type.name} style={{ direction: locale == "ar" ? "rtl" : "ltr" }} >
                          <em>{type && type.name}</em>
                        </MenuItem>
                      ))}
                    </Customeselect>
                  </CustomeFormControl>
                </CustomeBorder>
                {/* </div> */}
                <div className={style.TwoFlexButton}>
                  <button
                    className={style.borderBtnBooking + " " + style.BgTeal + "  " + style.White}
                    style={{ height: "50px", width: "100px" }}
                    type="submit"
                    variant="contained"
                    // text={"ابحث"}
                    onClick={(e) => handleSubmit(e)}

                    fullWidth
                  >
                    {t("placeholder")}
                  </button>
                </div>
              </div>

              <div className={style.SectionContainer}>
                <div className={style.allcard}>

                  {ReservationsList && ReservationsList.length > 0 ? ReservationsList.map(item => {

                    return (
                      <Cards
                        callbackReload={callbackReload}
                        reservation={item}
                      />
                    )
                  }) : ""}
                </div>
              </div>
              {showloading ? <div style={{ textAlign: "center" }}><LoadingJSON start={showloading} id={"reservationLoadingId"}></LoadingJSON></div> : ""}
              {LoadMore == true && ReservationsList.length ? (

                <SeeMore getMore={getMore} />

              ) : (
                  ""
                )}
              {NotFound ? (
                <p style={{ textAlign: "center", fontSize: " 1.2rem" }}>
                  {" "}
                  {t("Notfound")}
                </p>
              ) : (
                  ""
                )}
            </ div>
          </>}
      </Navbar>
    </div>
  )
}

export default Main
